import React from 'react'
import ServiceLocator from 'live/services/service-locator'
import { DvDTabContent } from './tabs/DvDTabContent'
import { WellPanTabContent } from './tabs/WellPanTabContent'
import ExtensionService from 'live/services/extension'
import Form from './form'
import { canViewDvDData, canViewWellPlanData } from '../daysVsDepth/permission/Permissions'
import { DvDDataContextProvider } from '../daysVsDepth/context/DvDDataContext'
const extension = {
    name: 'Days vs Depth Sync Configuration',
    type: 'dvd-config',
    origin: 'Live Days vs Depth Sync Configuration',
    roles: [],
    icon: '/content/plugin-adnoc-ilt/icon.png',
    ui: {
        form: Form,
        view: null
    }
}
ExtensionService.register(extension)

if (canViewWellPlanData()) {
    ServiceLocator.getService('asset-tab-service').then(service => {
        service.register({
            step: 'well-plan',
            assetType: 'wells',
            label: 'Well Plan',
            shouldHide: false,
            body: props => (
                <React.Suspense fallback={'loading'}>
                    <WellPanTabContent {...props} />
                </React.Suspense>
            )
        })
    })
}

if (canViewDvDData()) {
    ServiceLocator.getService('asset-tab-service').then(service => {
        service.register({
            step: 'days-vs-depth',
            assetType: 'wells',
            label: 'Days vs Depth',
            shouldHide: false,
            body: props => (
                <React.Suspense fallback={'loading'}>
                    <DvDDataContextProvider>
                        <DvDTabContent {...props} />
                    </DvDDataContextProvider>
                </React.Suspense>
            )
        })
    })
}
